import React, { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

function isOverflown(element) {
    return (
        element &&
        (element.scrollHeight > element.clientHeight ||
        element.scrollWidth > element.clientWidth)
    );
}

/**
 * A reusable component that shows text truncated to a specified number of lines.
 * If the text overflows, hovering over it shows the full text in a popper.
 */
const ExpandableText = function ExpandableText({
    text,
    width,
    lineClamp = 2,
    isHeader = false,
}) {

    const textRef = useRef(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseEnter = () => {
        const currentlyOverflown = isOverflown(textRef.current);
        setShowTooltip(currentlyOverflown);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <Tooltip
            title={text}
            arrow
            placement="bottom-start"
            open={showTooltip}
            disableHoverListener
            disableFocusListener
            disableTouchListener
        >
            <Box
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'inherit',
                    position: 'relative',
                    lineHeight: '1.4em',
                    width: '100%',
                    height: '100%',
                    textAlign: 'inherit',
                    ...(isHeader && {
                        fontWeight: 'bold',
                        fontSize: '0.875rem',
                    }),
                }}
            >
                <Box
                    ref={textRef}
                    sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitLineClamp: lineClamp,
                        WebkitBoxOrient: 'vertical',
                        maxWidth: width,
                        textAlign: 'inherit',
                    }}
                >
                    {text}
                </Box>
            </Box>
        </Tooltip>
    );
};

export default ExpandableText;
